import { computed, Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    private readonly requestCount = signal(0);

    readonly loading = computed(() => this.requestCount() > 0);
    readonly count = this.requestCount.asReadonly();

    show() {
        this.requestCount.update((count) => count + 1);
    }

    hide() {
        this.requestCount.update((count) => Math.max(0, count - 1));
    }

    clear() {
        this.requestCount.set(0);
    }
}
